import { isReservedDataFactoryUser, } from "@cappelendamm/user-services";
export const dataFactoryDataToUserData = (dataFactoryUser) => {
    const { addresses, names, personDetail } = dataFactoryUser;
    const { firstName, lastName } = names?.[0] || {};
    const { address, postalCode, city } = addresses?.[0] || {};
    return {
        firstName,
        lastName,
        address,
        postalCode,
        city,
        birthDate: personDetail?.birthDate ?? "",
    };
};
const formDataToUserData = (customer) => {
    return {
        firstName: customer.firstName,
        lastName: customer.lastName,
        address: customer.addresses.billing.street ?? "",
        postalCode: customer.addresses.billing.postalCode ?? "",
        city: customer.addresses.billing.city ?? "",
        birthDate: customer.birthDate ?? "",
    };
};
const removeFormatting = (input) => {
    return input?.toLowerCase().replace(/\s|-|,|/gm, "");
};
const compareField = (formInput, dataFactoryField) => {
    return removeFormatting(formInput) === removeFormatting(dataFactoryField);
};
export const compareFormDataToDataFactoryData = (form, dataFactoryData) => {
    const nonMatchingFields = [];
    const formKeys = Object.keys(form);
    for (const key of formKeys) {
        if (!compareField(form[key], dataFactoryData[key])) {
            nonMatchingFields.push(key);
        }
    }
    return {
        match: nonMatchingFields.length > 0 ? "noMatch" : "match",
        nonMatchingFields,
    };
};
export const compareDataFactoryData = async ({ customer, dataFactoryUser, }) => {
    if (!dataFactoryUser || isReservedDataFactoryUser(dataFactoryUser)) {
        return {
            match: "noData",
        };
    }
    const dataFactoryData = dataFactoryDataToUserData(dataFactoryUser);
    const customerFormData = formDataToUserData(customer);
    const comparisionResult = compareFormDataToDataFactoryData(customerFormData, dataFactoryData);
    return {
        dataFactoryData: dataFactoryUser,
        ...comparisionResult,
    };
};
